export default __webpack_public_path__ + "static/media/shop-by-shape.5adeffb4.png";